import {CompanyTariffShortRecord} from '../../../global/api';

export const getTariffRestriction = (tariff: CompanyTariffShortRecord | undefined, checkDiskSpace = false) => {
  if (tariff?.status === 'CLOSED') {
    return 'Оплаченный период закончился. Доступ к полному функционалу ограничен. Пополните баланс в соответствии с вашим тарифом.';
  }

  if (
    checkDiskSpace &&
    tariff?.usedDiskSpace != null &&
    tariff.diskSpace != null &&
    tariff.usedDiskSpace > tariff.diskSpace
  ) {
    return 'Доступное место закончилось. Удалите файлы или увеличьте объём хранилища.';
  }

  return null;
};
